var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.RESEND()
          },
        },
      },
      [
        _c("p", { staticClass: "input-title mb-3" }, [
          _vm._v("¿No has recibido el correo?"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mb-3" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-x w-100",
              attrs: { type: "submit" },
            },
            [
              _vm.count == 1
                ? _c(
                    "div",
                    {
                      staticClass: "spinner-border spinner-border-sm",
                      attrs: { role: "status" },
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Loading..."),
                      ]),
                    ]
                  )
                : _c("span", [_vm._v("Reenviar correo de activación")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-dark btn-x w-100",
                attrs: { to: { name: "Login" } },
              },
              [_c("span", [_vm._v("Atrás para iniciar sesión")])]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4 mb-5 text-left" }, [
      _c("p", { staticClass: "text-lg mb-1" }, [
        _vm._v("Gracias por afiliarte"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-sm text-muted" }, [
        _vm._v(
          "Le hemos enviado un enlace de activación a tu correo electrónico registrado. Utilice el enlace de activación para activar tu cuenta."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }